module.exports = __webpack_public_path__ + "img/plutchik.6d82672e.svg";